import { SelectButton } from "primereact/selectbutton";
import { Tooltip } from "primereact/tooltip";

import {
  actionTooltipProps,
  Dropdown,
  ListToolbar,
  MonthRangePicker,
  TableActionsMenu,
} from "@/ds";
import { FiltersPopover } from "@/shared/components/filters-popover";

import type { CargaToolbarViewModel } from "./types-carga-toolbar";
import styles from "./carga-toolbar.module.scss";

function agrupamentoValue(option: { label: string } | null) {
  return (
    <span>
      <strong>Agrupar por:</strong> {option?.label ?? ""}
    </span>
  );
}

export function CargaToolbarView({
  ids,
  search,
  onSearch,
  searchLabel,
  searchPlaceholder,
  searchMaxLength,
  periodo,
  onPeriodo,
  agrupamento,
  filtros,
  perspectivas,
  entrarSimulacao,
  menu,
  historico,
  simulacaoDesabilitada,
}: CargaToolbarViewModel) {
  return (
    <ListToolbar.Root
      testId={ids.toolbar}
      framed={false}
      aria-label="Barra da Carga de Trabalho"
      className={styles.toolbar}
      data-print-hide
    >
      <ListToolbar.Search
        value={search}
        onChange={onSearch}
        placeholder={searchPlaceholder}
        aria-label={searchLabel}
        maxLength={searchMaxLength}
        className={styles.search}
        clearable
        testId={ids.search}
      />

      <ListToolbar.Filters className={styles.filters}>
        <MonthRangePicker
          value={periodo}
          onChange={onPeriodo}
          className={styles.periodo}
          testId={ids.periodo}
        />
        <span className={styles.agrupamento} data-testid={ids.agrupamentoHint}>
          <Tooltip
            target={`.${styles.agrupamento}`}
            {...actionTooltipProps(agrupamento.hint, { showDelay: 150 })}
          />
          <Dropdown
            value={agrupamento.value}
            options={[...agrupamento.options]}
            onChange={(event) => agrupamento.onChange(event.value as string)}
            valueTemplate={agrupamentoValue}
            aria-label="Agrupar por"
            disabled={agrupamento.disabled}
            data-testid={ids.agrupamento}
          />
        </span>
        <FiltersPopover
          definitions={filtros.definitions}
          value={filtros.value}
          onChange={filtros.onChange}
          savedFilters={filtros.savedFilters}
          onSaveFilter={filtros.onSaveFilter}
          onDeleteSavedFilter={filtros.onDeleteSavedFilter}
          onApplySavedFilter={filtros.onApplySavedFilter}
          testId={ids.filtros}
        />
      </ListToolbar.Filters>

      <ListToolbar.Actions className={styles.acoes}>
        <SelectButton
          className="p-selectbutton-trilho"
          value={perspectivas.value}
          options={[...perspectivas.options]}
          onChange={perspectivas.onChange}
          pt={perspectivas.pt}
          aria-label="Perspectiva"
          data-testid={ids.perspectivas}
        />
      </ListToolbar.Actions>

      <ListToolbar.Menu>
        <TableActionsMenu.Root aria-label="Mais ações">
          <TableActionsMenu.Trigger data-testid={ids.menu} />
          {entrarSimulacao ? (
            <TableActionsMenu.Item
              label="Modo Simulação"
              icon="pi pi-play-circle"
              disabled={simulacaoDesabilitada}
              onClick={entrarSimulacao}
              testId="carga-menu-simulacao"
            />
          ) : null}
          {historico ? (
            <TableActionsMenu.Item
              label={historico.label}
              icon="pi pi-history"
              onClick={historico.onAbrir}
              testId="carga-menu-historico"
            />
          ) : null}
          {menu.onPapeis ? (
            <TableActionsMenu.Item
              label="Configurar Papéis na Obra"
              icon="users"
              onClick={menu.onPapeis}
              testId={ids.menuPapeis}
            />
          ) : null}
          <TableActionsMenu.Item
            label="Exportar Visualização"
            icon="download"
            disabled={!menu.canExport}
            onClick={menu.onExportar}
            testId={ids.menuExportar}
          />
          <TableActionsMenu.Item
            label="Mostrar/Ocultar Indicadores"
            icon="eye"
            onClick={menu.onIndicadores}
            testId={ids.menuIndicadores}
          />
        </TableActionsMenu.Root>
      </ListToolbar.Menu>
    </ListToolbar.Root>
  );
}
